// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__xnSSp","author":"Table_author__1b4Zo","authorImage":"Table_authorImage__sDN-6","unreadRow":"Table_unreadRow__2lHJg"};